import { Link } from 'react-router-dom';
import AdSense from "react-adsense";
import { Cookies } from './../index.js';
import React, { useEffect, useState } from 'react';
import { Helmet } from "react-helmet";
import Options from "../shop/ai/options.jsx";
// JSON cấu hình cho các mục Link (nhóm 1)

function History() {
  const [type_user, settype_user] = useState('');
  const apikey = Cookies.get('apikey');

  return (
    <div className="row fixrow">
      {/* Ví dụ AdSense hoặc các phần khác có thể được comment lại hoặc giữ nguyên */}
      <Helmet>
        <title>Nhật ký sử dụng</title>
      </Helmet>
      <div className="max-h-16">
        <div className="cards">
          <AdSense.Google
            client="ca-pub-4574266110812955"
            slot="1627514116"
            style={{ display: 'block' }}
            format='horizontal'
            responsive='false'
          />
        </div>
      </div>
      {
        !apikey && (
          <div
            className="w-full max-w-xs mx-auto p-2 mx-4 rounded-2xl bg-pink-100 text-pink-800 
             dark:bg-gray-800 dark:text-pink-300 shadow-lg border border-pink-200 
             flex items-start gap-3 relative overflow-hidden"
            role="alert"
          >

            {/* floating emojis */}
            <div className="absolute bottom-1 left-2 text-lg animate-bounce">✨</div>
            <div className="absolute bottom-1 right-2 text-lg animate-pulse">🌸</div>

            {/* main icon */}
            <div className="text-3xl mt-1 animate-[bounce_1.5s_infinite]">📘</div>

            {/* text */}
            <div className="leading-snug">
              <div className="font-bold text-xl">Activity Log Preview</div>
              <div className="text-base mt-1">
                This is preview of how your activity history will appear. 💖✨
              </div>
            </div>

          </div>
        )
      }
      <Options />
    </div>
  );
}

export default History;
